export default {
  namespace: 'userHoverCard',
  en: {
    inactive: 'Inactive',
    portal: 'Portal',
    hasPortalAccess: 'Has portal access',
    noPortalAccess: 'No portal access',
    owner: 'Owner',
    ownerTooltip: 'This user is the account owner',
    external: 'External',
    roles: 'Roles',
    showLess: 'Show less',
    showMore: '+{{count}} more',
  },
  nl: {
    inactive: 'Inactief',
    portal: 'Portal',
    hasPortalAccess: 'Heeft toegang tot de portal',
    noPortalAccess: 'Geen toegang tot de portal',
    owner: 'Eigenaar',
    ownerTooltip: 'Deze gebruiker is eigenaar van het account',
    external: 'Extern',
    roles: 'Rollen',
    showLess: 'Toon minder',
    showMore: '+{{count}} meer',
  },
};
